import Box from "pages/_components/Box";
import { resizableRoute } from "pages/_components/Resizable";
import Text from "pages/_components/Text";
import { bool, string } from "prop-types";
import React from "react";

const EmptyTextBox = ({ className, footerLink, isDesktop, text }) => (
    <Box
        display="flex"
        column
        alignX="center"
        alignY="center"
        borderRadius="default"
        border="dashed-image-border-base-color"
        background="component-background"
        className={className}
        gap="4">
        <Box display="inline-block" className="full-width text-align-center">
            <Text size={isDesktop ? "small" : "body"} color="heading" align="center" className="mr-2" labelKey={text} />
        </Box>
        {footerLink && (
            <Box display="inline-block" className="full-width text-align-center">
                <Text
                    size={isDesktop ? "7" : "small"}
                    color="heading"
                    align="center"
                    labelKey="product.empty.footText.first"
                />
                <Text
                    size={isDesktop ? "7" : "small"}
                    color="heading"
                    align="center"
                    labelKey="product.empty.footText.second"
                />
            </Box>
        )}
    </Box>
);

EmptyTextBox.propTypes = {
    className: string,
    footerLink: bool,
    isDesktop: bool.isRequired,
    text: string,
};

EmptyTextBox.defaultProps = {
    className: "px-5 py-5 px-md-9 py-md-4 mt-md-12",
    footerLink: false,
    text: null,
};

export default resizableRoute(EmptyTextBox);
